import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AdminLayoutModule } from './layout/admin-layout/admin-layout.module';
import { AdminComponentsModule } from './components/admin.components.module';



@NgModule({
  declarations: [

  ],
  imports: [
    CommonModule,
    AdminLayoutModule,
    AdminComponentsModule,

  ],
schemas: [CUSTOM_ELEMENTS_SCHEMA],
  exports: [
   AdminLayoutModule
  ]
})
export class AdminModule { }
